import { USER_REQUEST, USER_ERROR, USER_SUCCESS, REQUEST_PERMISSIONS, USER_CONFIG, USER_GROUP } from 'actions/user'
import Vue from 'vue'
import { AUTH_LOGOUT } from 'actions/authentication'
import http from 'utils/http'
import { COMPANY_LIST } from 'actions/company'

const state = {
	status: '',
	profile: JSON.parse(localStorage.getItem('user-profile')) || {},
	permissions: JSON.parse(localStorage.getItem('permissions')) || [],
	companyList: JSON.parse(localStorage.getItem('company-list')) || [],
	companyListLoaded: JSON.parse(localStorage.getItem('company-list-loaded')) || false,
	groups: [],
	role: JSON.parse(localStorage.getItem('user-role')) || null
}

const getters = {
	getProfile: state => state.profile,
	isProfileLoaded: state => !!state.profile.id,
	getPermissions: state => state.permissions,
	getCompanyList: state => state.companyList,
	getStatusCompanyLoad: state => state.companyListLoaded,
	getGroups: state => state.groups,
	getRole: state => state.role
}

const actions = {
	[USER_REQUEST]: ({ commit, dispatch }) => {
		return new Promise(resolve => {
			commit(USER_REQUEST)

			const userProfile = http.get('/user/me')
			const companyList = http.post('/company/list')

			http.all([userProfile, companyList])
				.then(http.spread((userProfile, companyList) => {
					commit(USER_SUCCESS, userProfile.data)
					commit(COMPANY_LIST, companyList.data)
					resolve({
						userProfile: userProfile.data,
						companyList: companyList.data
					})
				}))
				.catch(err => {
					commit(USER_ERROR)
					// if resp is unauthorized, logout, to
					dispatch(AUTH_LOGOUT)
					Vue.rollbar.error('USER_REQUEST', err)
				})
		})
	},
	[USER_CONFIG]: ({ commit }, key) => {
		let config = JSON.parse(localStorage.getItem(key))

		if (config) {
			return config
		} else {
			return http.post('/user-config/get', null, {
				params: { key: key }
			})
				.then((resp) => {
					commit(USER_CONFIG, {
						data: resp.data,
						key
					})
					return resp.data
				})
				.catch(error => {
					console.log(error)
					Vue.rollbar.error('USER_CONFIG', error)
				})
		}
	},
	[REQUEST_PERMISSIONS]: ({ commit, dispatch }) => {
		return new Promise(resolve => {
			http.get('/authorities/me')
				.then(resp => {
					commit(REQUEST_PERMISSIONS, resp.data)
					resolve()
				})
				.catch(error => {
					console.log(error)
					Vue.rollbar.error('REQUEST_PERMISSIONS', error)
				})
		})
	},
	[USER_GROUP]: ({commit}, companyId) => {
		return http.post('/company/groups', null, {
			params: {
				id: companyId
			}
		})
			.then(resp => {
				commit(USER_GROUP, resp.data)
			})
			.catch(error => {
				console.log(error)
				Vue.rollbar.error('USER_GROUP', error)
			})
	},
	'USER_ROLE': ({state}, load) => {
		if (load) {
			state.role = null
			localStorage.removeItem('user-role')
		}
		if (!state.role) {
			return http.get('/role/me', {})
				.then(resp => {
					state.role = resp.data
					localStorage.setItem('user-role', JSON.stringify(resp.data))
				})
				.catch(error => {
					console.log(error)
					Vue.rollbar.error('USER_ROLE', error)
				})
		}
	}
}

const mutations = {
	[USER_REQUEST]: state => {
		state.status = 'loading'
	},
	[USER_SUCCESS]: (state, resp) => {
		state.status = 'success'
		localStorage.setItem('user-profile', JSON.stringify(resp))
		Vue.set(state, 'profile', resp)
	},
	[USER_ERROR]: state => {
		state.status = 'error'
	},
	[USER_CONFIG]: (state, config) => {
		localStorage.setItem(config.key, JSON.stringify(config.data))
	},
	[AUTH_LOGOUT]: state => {
		state.profile = {}
		state.companyList = []
		state.permissions = []
		state.companyListLoaded = false
	},
	[REQUEST_PERMISSIONS]: (state, resp) => {
		if (state.permissions.length === 0) {
			state.permissions = resp
		}
		localStorage.setItem('permissions', JSON.stringify(resp))
	},
	[COMPANY_LIST]: (state, resp) => {
		localStorage.setItem('company-list', JSON.stringify(resp))
		localStorage.setItem('company-list-loaded', JSON.stringify(true))
		Vue.set(state, 'companyList', resp)
		state.companyListLoaded = true
	},
	[USER_GROUP]: (state, groups) => {
		state.groups = groups
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}
